document.addEventListener("DOMContentLoaded", function () {
  // Ensure GSAP and ScrollTrigger are loaded safely
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);

    // Initialize parallax animations
    initParallaxGallery();
  }
});

function initParallaxGallery() {
  const targetSection = document.querySelector(".parallax-section");
  if (!targetSection) return;

  const leftImage = targetSection.querySelector(".img-left");
  const rightImage = targetSection.querySelector(".img-right");

  // GSAP Timeline mapped to Scroll Progress
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: targetSection,
      start: "top bottom", // Starts as soon as the section bottom edges touch viewport
      end: "bottom top",   // Ends when it scrolls past completely
      scrub: 1.2,          // Higher value add more 'smooth weight/inertia' to mouse wheel wheel
    }
  });

  // Left Image: Slants slightly left, starts lower down and moves upward
  tl.fromTo(leftImage, 
    { 
      y: "80px", 
      rotation: -12 
    }, 
    { 
      y: "-120px", 
      rotation: -6,
      ease: "none" 
    }, 
    0
  );

  // Right Image: Slants slightly right, starts higher up and moves downward
  tl.fromTo(rightImage, 
    { 
      y: "-100px", 
      rotation: 12 
    }, 
    { 
      y: "100px", 
      rotation: 6,
      ease: "none" 
    }, 
    0
  );
}

// Ensure theme editor customization updates without requiring refreshing pages
if (window.shopifyHTML) {
  document.addEventListener("shopify:section:load", function() {
    initParallaxGallery();
  });
}